//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 验证码输入框
 */
import smsApi from 'api/sms';
export default {
  name: 'securityCode',
  props: {
    // 验证码
    value: String,
    // 手机号码
    mobile: {
      type: String
    },
    error: Boolean,
    imgCode: String
  },
  data: function data() {
    return {
      loading: false,
      showCountDown: false,
      time: 60 * 1000,
      code: null
    };
  },
  watch: {
    code: function code(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    sendCode: function sendCode() {
      var _this = this;

      if (this.mobile != null) {
        if (this.imgCode != null && this.imgCode != '') {
          this.loading = true;
          smsApi.sendCode({
            mobile: this.mobile,
            imgcode: this.imgCode
          }).then(function (res) {
            if (res.type === 'SUCCESS') {
              _this.showCountDown = true;
            }

            _this.loading = false;
          }).catch(function () {
            _this.loading = false;
          });
        } else {
          this.$toast('请输入图形验证码');
        }
      } else {
        this.$toast('请输入手机号码');
      }
    }
  }
};